import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Table } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { CustomButton, CustomModal, CustomText, CustomTextArea, FormDatePicker, FormInput, FormSelect, useCustomToast } from "../../../../../components";
import { Asset } from "../ModalAddItemActivo";
import ModalAssessment from "./ModalAssesment";
import { TechnicalConceptAPI } from "../../../api/technicalConceptAPI";
import dayjs from "dayjs";
import { useAtom } from "jotai";
import { authAtom } from "../../../../../state";

interface IModalManageItem {
  isModalManageItem: boolean;
  setIsModalManageItem: (value: boolean) => void;
  selectedItem: Asset | null;
  title: string;
  formik: any;
  formikReturnPetition: any;
  formikApprovePetition: any;
  status_id: string;
  refetchId?: () => void;
  detailData?: any;
  refetch?: () => void;
}

export interface EvaluationItem {
  id: number;
  documents: any[];
  listaPredefinida: string;
  caracteristica: string;
  descripcionRevision: string;
  delivery_deadline?: string;
  observations: string | null;
  status_id?: string;
  status: string;
  predefined_list_aspect_id?: string;
}


interface PredefinedList {
  id: number;
  name: string;
  predefined_list_aspects: {
    id: number;
    aspect: string;
    description: string;
  }[];
  users: {
    id: number;
    name: string;
    email: string;
  }[];
}

const opsRoles = [
  { id: "FUNCIONARIO", name: "Funcionario" },
  { id: "CONTRATISTA", name: "Contratista" },
  { id: "PROVEEDOR", name: "Proveedor" },
];

const ModalManageItem: React.FC<IModalManageItem> = ({
  isModalManageItem,
  setIsModalManageItem,
  selectedItem,
  title,
  formik,
  formikReturnPetition,
  formikApprovePetition,
  status_id,
  refetchId,
  detailData,
  refetch,
}) => {
  const [listasEstablecidas, setListasEstablecidas] = useState<EvaluationItem[]>([]);
  const [isModalEvaluarOpen, setIsModalEvaluarOpen] = useState(false);
  const [isModalReturnOpen, setIsModalReturnOpen] = useState(false);
  const [isModalApproveOpen, setIsModalApproveOpen] = useState(false);
  const [selectedEvaluation, setSelectedEvaluation] = useState<EvaluationItem | null>(null);
  const [status, setStatus] = useState<{ id: string; name: string }[]>([]);
  const [typifications, setTypifications] = useState<{ id: string; name: string }[]>([]);
  const [predefinedList, setPredefined] = useState<PredefinedList[]>([]);
  const [aspectOptions, setAspectOptions] = useState<{ id: string; name: string; description: string }[]>([]);
  const [selectedAspectDescription, setSelectedAspectDescription] = useState<string>("");
  const [userList, setUserList] = useState<{ id: string; name: string; email: string }[]>([]);
  const { showToast } = useCustomToast();
  const [validate, setValidate] = React.useState<{ isReturn: boolean; isApproval: boolean; isRejected: boolean; isRegister: boolean; isFinalized: boolean }>({
    isReturn: false,
    isApproval: false,
    isRejected: false,
    isRegister: false,
    isFinalized: false
  });
  const [authData] = useAtom(authAtom);
  const isAproveRole = authData?.portalPermissions?.includes('webportal-technical-concept') || authData?.superadmin;
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const dataStastus = await TechnicalConceptAPI.fetchParameters(['concept_element_status', 'technical_concept']);
        setStatus(dataStastus.concept_element_status.map((item: any) => ({
          id: String(item.id),
          name: item.status,
        })) || []);
        setTypifications(dataStastus.technical_concept.map((item: any) => ({
          id: String(item.id),
          name: item.name,
        })) || []);
      } catch (error) {
        console.error("Error fetching status:", error);
      }
    };
    fetchStatus();
  }, [isModalApproveOpen]);

  useEffect(() => {
    const fetchData = async () => {
      try {

        const assetClassId = selectedItem?.asset_class ? selectedItem.asset_class.id.toString() : '';

        const data = await TechnicalConceptAPI.fetchParameters(
          ['predefined_list'],
          { asset_class_id: assetClassId }
        );
        if (data) setPredefined(data.predefined_list || []);
      } catch (error) {
        console.error('Error fetching parameters:', error);
      }
    };
    fetchData();
  }, [selectedItem]);

  useEffect(() => {
    setValidate({
      isApproval: ['68', '37'].includes(status_id),
      isReturn: ['75'].includes(status_id),
      isRejected: ['10', '11'].includes(status_id),
      isRegister: ['67'].includes(status_id),
      isFinalized: ['7'].includes(status_id)
    });

  }, [selectedItem]);

  useEffect(() => {
    const selectedPredefined = predefinedList.find((list) => list.id.toString() === formik.values.listaPredefinida);

    if (selectedPredefined?.predefined_list_aspects) {
      setAspectOptions(
        selectedPredefined.predefined_list_aspects.map((aspect) => ({
          id: aspect.id.toString(),
          name: aspect.aspect,
          description: aspect.description,
        }))
      );
    } else {
      setAspectOptions([]);
    }

    formik.setFieldValue("caracteristica", "");
    setSelectedAspectDescription("");
  }, [formik.values.listaPredefinida, predefinedList]);

  useEffect(() => {
    const fetchUserList = async () => {
      if (selectedItem && selectedItem.delivery_deadline) {
        formik.setFieldValue("delivery_date", dayjs(selectedItem.delivery_deadline));
        formik.setFieldValue("rolTecnico", selectedItem.user_role?.toUpperCase() || "");
        formik.setFieldValue("listaPredefinida", String(selectedItem.evaluations?.[0]?.predefined_list_id || ""));
        formik.setFieldValue("emailTecnico", selectedItem.user_email || "");
        formik.setFieldValue("nameTecnico", String(selectedItem.user_id) || "");
        const users = await fetchUserListByRole(
          selectedItem.user_role?.toUpperCase() || "",
          String(selectedItem.evaluations?.[0]?.predefined_list_id ?? "")
        );
        setUserList(users)

        if (selectedItem.evaluations) {
          setValuesEvaluations(selectedItem);
          return;
        }
      }

      setListasEstablecidas([]);
    };

    fetchUserList();
  }, [selectedItem, predefinedList]);


  const setValuesEvaluations = (selectedItem: any) => {
    const evaluations: EvaluationItem[] = selectedItem.evaluations.map((evaluation: any) => ({
      id: evaluation.id,
      codigo: evaluation.id,
      listaPredefinida: evaluation.predefined_list,
      caracteristica: evaluation.predefined_list_aspect,
      predefined_list_aspect_id: evaluation.predefined_list_aspect_id,
      descripcionRevision: evaluation.predefined_list_description,
      tecnico: evaluation.user,
      status: evaluation.status,
      status_id: evaluation.status_id !== '25' ? evaluation.status_id : '',
      rol: evaluation.user_role,
      documents: evaluation.documents || [],
      observations: evaluation.observations || '',
      delivery_deadline: evaluation.delivery_deadline || "",
    }));
    setListasEstablecidas(evaluations);
  }

  const onChangeRole = async (value: string) => {
    if (validate.isApproval) return;
    formik.setFieldValue("rolTecnico", value);
    formik.setFieldValue("nameTecnico", "");
    formik.setFieldValue("emailTecnico", "");
    const users = await fetchUserListByRole(value, formik.values.listaPredefinida)
    setUserList(users)
  }

  const onChangeListaPredefinida = async (value: string) => {
    setListasEstablecidas([]);
    formik.setFieldValue("listaPredefinida", value)
  }

  const fetchUserListByRole = async (role: string, id_predefinida: string) => {
    if (role === "FUNCIONARIO") {
      return (
        predefinedList.find((list) => list.id.toString() == id_predefinida)
          ?.users?.map((it: any) => ({
            id: it.id.toString(),
            name: it.document + ' - ' + it.name + ' ' + it.last_name,
            email: it.email,
          })) || []
      );
    }

    if (role === "CONTRATISTA") {
      const data = await TechnicalConceptAPI.fetchParameters(['contractor_third_party']);
      return (
        data?.contractor_third_party?.map((it: any) => ({
          id: it.id.toString(),
          name: it.document + ' - ' + it.name,
          email: it.email,
        })) || []
      );
    }

    if (role === "PROVEEDOR") {
      const data = await TechnicalConceptAPI.fetchParameters(['provider_third_party']);
      return (
        data?.provider_third_party?.map((it: any) => ({
          id: it.id.toString(),
          name: it.document + ' - ' + it.name,
          email: it.email,
        })) || []
      );
    }

    return [];
  };

  const onChangeNameTec = (value: string) => {
    formik.setFieldValue("nameTecnico", value);
    const selectedUser = userList.find((user) => user.id === value);
    formik.setFieldValue("emailTecnico", selectedUser?.email || "");
  }

  const handleAspectChange = (value: string) => {
    formik.setFieldValue("caracteristica", value);
    const selectedAspect = aspectOptions.find((aspect) => aspect.id === value);
    setSelectedAspectDescription(selectedAspect?.description || "");
  };

  const handleEvaluateItem = (record: EvaluationItem) => {
    setSelectedEvaluation(record);
    setIsModalEvaluarOpen(true);
  };

  const handleRemoveItem = (id: number) => {
    setListasEstablecidas(listasEstablecidas.filter((item) => item.id !== id));
  };

  const handleAddList = async () => {

    const { listaPredefinida, caracteristica } = formik.values;

    if (!listaPredefinida || !caracteristica) {
      showToast("error", "Por favor complete todos los campos antes de añadir a la lista.")
      return;
    }

    const lista = predefinedList.find((x) => x.id === Number(listaPredefinida));
    const listaNombre = lista?.name || "";

    if (caracteristica === "all" && lista?.predefined_list_aspects?.length) {
      const nextId = listasEstablecidas.length + 1;
      const items = lista.predefined_list_aspects.map((aspect, idx) => ({
        id: nextId + idx,
        documents: [],
        listaPredefinida: listaNombre,
        caracteristica: aspect.aspect,
        predefined_list_aspect_id: aspect.id.toString(),
        descripcionRevision: aspect.description,
        status: 'Sin registro',
        observations: formik.values.observations || null,
      }));

      setListasEstablecidas((prev) => [...prev, ...items]);
    } else if (caracteristica !== "all") {
      const aspecto = aspectOptions.find((x) => x.id === formik.values.caracteristica);
      setListasEstablecidas((prev) => [
        ...prev,
        {
          id: prev.length + 1,
          documents: [],
          listaPredefinida: listaNombre,
          caracteristica: aspecto?.name || "",
          predefined_list_aspect_id: formik.values.caracteristica,
          descripcionRevision: selectedAspectDescription,
          status: 'Sin registro',
          observations: formik.values.observations || null,
        },
      ]);
    }

    formik.setFieldValue("caracteristica", "");
    setSelectedAspectDescription("");
  };

  const onReturnItem = async () => {
    if (!formikReturnPetition.values.reason) {
      showToast("error", "Por favor ingrese una observación antes de devolver la petición.");
      return;
    }
    formikReturnPetition.setFieldValue("observations", formikReturnPetition.values.observations);
    setIsModalReturnOpen(false);
    setIsModalManageItem(false);
    formikReturnPetition.handleSubmit();
  }

  const buildEvaluations = (listas: any) => {
    return listas?.map((item: any) => ({
      id: item.id,
      predefined_list_aspect_id: item.predefined_list_aspect_id,
    }));
  };

  const buildItem = (selectedItem: any, formikValues: any, evaluations: any) => {
    const base = {
      ...selectedItem,
      delivery_deadline: dayjs(formikValues.delivery_date).format("YYYY-MM-DD"),
      expert_email: formikValues.emailTecnico,
      evaluations,
    };

    if (formikValues.rolTecnico === 'FUNCIONARIO') {
      return { ...base, expert_id: formikValues.nameTecnico };
    } else {
      return { ...base, third_party_id: formikValues.nameTecnico };
    }
  };

  const submit = async () => {
    const evaluations = buildEvaluations(listasEstablecidas);
    const item = buildItem(selectedItem, formik.values, evaluations);

    formik.setFieldValue("items", [item]);
    setIsModalManageItem(false);
    formik.handleSubmit();
  };

  const handleSubmitSendForEvaluation = () => {
    if (listasEstablecidas.length === 0) {
      showToast("error", "Debe añadir al menos una lista antes de enviar para evaluar.");
      return;
    }
    submit()
  }

  const onApprovePetition = async () => {
    const evaluations = buildEvaluations(listasEstablecidas);
    const item = buildItem(selectedItem, formik.values, evaluations);

    formikApprovePetition.setFieldValue("items", [item]);
    setIsModalApproveOpen(false);
    setIsModalManageItem(false);
    formikApprovePetition.handleSubmit();
  }

  useEffect(() => {
    if (selectedItem && selectedItem.evaluations && detailData) {
      setValuesEvaluations(detailData[0] || []);
    }
  }, [selectedItem, detailData]);

  return (
    <>
      <Modal
        width="95vw"
        title={title}
        open={isModalManageItem}
        onCancel={() => setIsModalManageItem(false)}
        footer={[
          <CustomButton key="cancel" label={!isAproveRole && status_id === '37' ? "Finalizar" : "Cancelar"} onClick={() => {
            formik.resetForm();             
            setListasEstablecidas([]);       
            setIsModalManageItem(false);    
          }} buttonType="secondary" />,
          ((validate.isApproval || validate.isReturn) && (status_id !== '68' && status_id !== '75') && isAproveRole) && (
            <CustomButton
              key="return"
              label="Devolver al técnico"
              onClick={() => setIsModalReturnOpen(true)}
              buttonType="secondary"
            />
          ),
          (isAproveRole && ['37'].includes(status_id) && <CustomButton key="approve" label="Aprobar" onClick={() => setIsModalApproveOpen(true)} />),
          (['67'].includes(status_id) && <CustomButton key="send" label="Enviar para evaluar" onClick={handleSubmitSendForEvaluation} />),
          (['68', '75'].includes(status_id) && <CustomButton key="save" label="Guardar" onClick={() => setIsModalManageItem(false)} />)
        ]}
      >
        <form onSubmit={formik.handleSubmit}>
          <Table
            dataSource={selectedItem ? [selectedItem] : []}
            columns={[
              { title: 'Item', dataIndex: 'id', key: 'id' },
              { title: 'Código/placa', dataIndex: 'plate_code', key: 'plate_code' },
              { title: 'Descripción', dataIndex: 'description', key: 'description' },
              {
                title: 'Clase de activos',
                dataIndex: 'asset_class',
                key: 'asset_class',
                render: (_: any, record: Asset) =>
                  record.asset_class
                    ? `${record.asset_class.code} - ${record.asset_class.name}`
                    : 'N/A',
              },
              {
                title: 'Artículo',
                dataIndex: 'asset_items',
                key: 'asset_items',
                render: (_: any, record: Asset) =>
                  record.item
                    ? `${record.item.code} - ${record.item.name}`
                    : 'N/A',
              },
              { title: 'Adiciones', dataIndex: 'assets_count', key: 'assets_count', render: (text: number) => text || 0 },
              { title: 'Estado del bien', dataIndex: 'status', key: 'status' },
            ]}
            pagination={false}
          />

          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col xs={8}>
              <FormDatePicker
                label="Plazo de entrega"
                name="delivery_date"
                value={formik.values.delivery_date}
                error={formik.errors.delivery_date}
                touched={formik.touched.delivery_date}
                onChange={(value) => formik.setFieldValue('delivery_date', value)}
                onBlur={() => formik.setFieldTouched("delivery_date", true)}
                disabled={validate.isApproval || validate.isReturn}
                disabledDate={(current) => current && current < dayjs().startOf('day')}
              />
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "20px", borderTop: "1px solid #ccc", borderBottom: "1px solid #ccc", padding: "20px 0" }}>
            <Col xs={24} sm={6}>
              <FormSelect
                label="Lista predefinida"
                name="listaPredefinida"
                placeholder="Seleccione"
                value={formik.values.listaPredefinida}
                onChange={onChangeListaPredefinida}
                options={predefinedList.map((x) => ({ name: x.name, id: x.id.toString() }))}
                onBlur={() => formik.setFieldTouched("listaPredefinida", true)}
                disabled={validate.isApproval || validate.isReturn}
              />
            </Col>
            <Col xs={24} sm={6}>
              <FormSelect
                label="Rol del técnico"
                name="rolTecnico"
                placeholder="Seleccione"
                value={formik.values.rolTecnico}
                onChange={onChangeRole}
                options={opsRoles}
                onBlur={() => formik.setFieldTouched("rolTecnico", true)}
                disabled={validate.isApproval || validate.isReturn}
              />
            </Col>
            <Col xs={24} sm={6}>
              <FormSelect
                label="Nombre del técnico"
                name="nameTecnico"
                placeholder="Seleccione"
                value={formik.values.nameTecnico}
                onChange={onChangeNameTec}
                options={userList}
                onBlur={() => formik.setFieldTouched("nameTecnico", true)}
                disabled={validate.isApproval || validate.isReturn}
              />
            </Col>
            <Col xs={24} sm={6}>
              <FormInput
                label="Correo del técnico"
                name="emailTecnico"
                value={formik.values.emailTecnico}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Ingrese"
                disabled={validate.isApproval || validate.isReturn}
              />
            </Col>
          </Row>

          {(!validate.isApproval && !validate.isFinalized && !validate.isReturn) && <section style={{ marginTop: "20px", borderBottom: "1px solid #ccc", padding: "20px 0" }}>
            <CustomText text="Listas establecidas" strong fontSize="big" />
            <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
              <Col xs={8}>
                <FormSelect
                  label="Característica o aspecto"
                  name="caracteristica"
                  placeholder="Seleccione"
                  value={formik.values.caracteristica}
                  onChange={handleAspectChange}
                  options={
                    aspectOptions.length > 0
                      ? [
                          { name: 'Todos', id: 'all' },
                          ...aspectOptions.map((aspect) => ({
                            id: aspect.id,
                            name: aspect.name,
                            description: aspect.description,
                          })),
                        ]
                      : []
                  }
                  onBlur={() => formik.setFieldTouched("caracteristica", true)}
                  disabled={false}
                />
              </Col>
              <Col xs={24} sm={16}>
                <FormInput
                  label="Descripción de la revisión"
                  name="descripcionRevision"
                  value={selectedAspectDescription}
                  disabled
                />
              </Col>
              {(!validate.isApproval && !validate.isReturn) && <Col xs={24}>
                <span style={{ display: "flex", justifyContent: "flex-end" }}>
                  <CustomButton label="Añadir" icon={<PlusOutlined />} onClick={handleAddList} />
                </span>
              </Col>}
            </Row>
          </section>}

          <Table
            dataSource={listasEstablecidas}
            columns={[
              { title: "Item", dataIndex: "id", key: "id" },
              { title: "Lista predefinida", dataIndex: "listaPredefinida", key: "listaPredefinida" },
              { title: "Característica o aspecto", dataIndex: "caracteristica", key: "caracteristica" },
              { title: "Descripción de la revisión", dataIndex: "descripcionRevision", key: "descripcionRevision" },
              { title: "Estado", dataIndex: "status", key: "status" },
              {
                title: "Acciones",
                key: "acciones",
                render: (_, record) => (
                  <span style={{ display: "flex", gap: "10px" }}>
                    {(validate.isApproval || validate.isReturn) && <Button type="link" onClick={() => handleEvaluateItem(record)}>{ status_id === '37' ? 'Ver' : 'Evaluar' }</Button>}
                    {(validate.isRegister) && <Button type="link" danger onClick={() => handleRemoveItem(record.id)}>Eliminar</Button>}
                  </span>
                ),
              },
            ]}
            pagination={false}
            style={{ marginTop: "20px" }}
          />
        </form>
      </Modal>

      {isModalEvaluarOpen && (
        <ModalAssessment
          isOpen={isModalEvaluarOpen}
          onClose={() => setIsModalEvaluarOpen(false)}
          evaluation={selectedEvaluation!}
          refetchId={refetchId}
          onSuccess={() => {
            if (
              detailData?.[0]?.evaluations.filter((item: EvaluationItem) => item.status === 'Pendiente').length === 1
            ) {
              refetch && refetch();
            }
          }}
          status_id={status_id}
        />
      )}

      {isModalReturnOpen && <CustomModal
        title="¿Desea devolver la solicitud al técnico?"
        labelSubmit="Aceptar"
        open={isModalReturnOpen}
        onSave={() => { onReturnItem() }}
        width={1000}
        onCancel={() => {
          formikReturnPetition.values.reason = "";
          setIsModalReturnOpen(false)
        }}
      >
        <CustomTextArea
          label="Observaciones"
          name="reason_return"
          placeholder="Ingrese observaciones"
          value={formikReturnPetition.values.reason}
          onChange={(e) => formikReturnPetition.setFieldValue("reason", e.target.value)}
          onBlur={formikReturnPetition.handleBlur}
        />
      </CustomModal>}


      {isModalApproveOpen && <CustomModal
        title="¿Desea aprobar y finalizar el proceso de concepto técnico?"
        labelSubmit="Aceptar"
        open={isModalApproveOpen}
        onSave={onApprovePetition}
        width={1000}
        onCancel={() => setIsModalApproveOpen(false)}
      >
        <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
          <Col xs={24} sm={12}>
            <FormSelect
              label="Estado del elemento"
              name="status_id"
              placeholder="Seleccione"
              value={formikApprovePetition.values.status_id}
              onChange={(value) => formikApprovePetition.setFieldValue("status_id", value)}
              options={status}
              onBlur={() => formikApprovePetition.setFieldTouched("status_id", true)}
            />
          </Col>
          <Col xs={24} sm={12}>
            <FormSelect
              label="Tipificación a concepto técnico"
              name="technical_concept_typification_id"
              placeholder="Seleccione"
              value={formikApprovePetition.values.technical_concept_typification_id}
              onChange={(option) => {
                formikApprovePetition.setFieldValue("technical_concept_typification_id", option)
              }}
              options={typifications}
              onBlur={() =>
                formikApprovePetition.setFieldTouched("technical_concept_typification_id", true)
              }
            />
          </Col>

          <Col xs={24}>
            <CustomTextArea
              label="Observaciones"
              name="reason"
              placeholder="Ingrese observaciones"
              value={formikApprovePetition.values.reason}
              onChange={formikApprovePetition.handleChange}
              onBlur={formikApprovePetition.handleBlur}
            />
          </Col>
        </Row>
      </CustomModal>}
    </>
  );
};

export default ModalManageItem;
